define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext", "./customerUserActions"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext, CPCustomerUserActions) {
    "use strict";
    var CPCustomerUsers = /** @class */ (function () {
        function CPCustomerUsers() {
            this.canExport = ko.observable(UserContext.hasAccess("Admin,CPCustomerUsers.Export"));
            this.userCanEditCPCustomerUser = ko.observable(UserContext.hasAccess("Admin,CPCustomerUsers.Edit,CPCustomerUsers.Delete"));
            this.userCanDeleteCPCustomerUser = ko.observable(UserContext.hasAccess("Admin,CPCustomerUsers.Delete"));
            this.filterByAny = ko.observable("");
        }
        CPCustomerUsers.prototype.init = function () {
            var self = this;
            $("#page-title").text("CP Customers Users");
            tools.ajaxGet({
                url: "/CPCustomerUsers/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.cpCustomerUsersLookupList = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.cpActions = new CPCustomerUserActions();
                    self.cpActions.afterSuccess = function () {
                        self.cpCustomerUsersTable.refresh();
                    };
                    self.initGrid(self.cpCustomerUsersLookupList.GridStructures.CPCustomerUsersStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CPCustomerUsers.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblCPCustomerUsersKendo";
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "150px",
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEditCPCustomerUser()) {
                        html += "<a class=\"btn btn-sm btn-yellow btn-edit\" title=\"Edit User\" href=\"#\"><i class=\"fa fa-edit\"></i></a>";
                        html += "&nbsp;<a class=\"btn btn-sm btn-info btn-send\" title=\"Resend Invitation\" href=\"#\"><i class=\"fa fa-paper-plane-o\"></i></a>";
                        html += "&nbsp;<a class=\"btn btn-sm btn-info mat-icon-btn btn-send-app\" title=\"Send SoftPhone Credentials\" href=\"#\"><i class=\"material-icons\">computer</i></a>";
                        html += "&nbsp;<a class=\"btn btn-sm btn-success btn-impersonate\" title=\"Impersonate User\" href=\"#\"><i class=\"fa fa-sign-in\"></i></a>";
                    }
                    if (self.userCanDeleteCPCustomerUser()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" title="Delete User" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.unshift(actions);
            var profileColumn = ko.utils.arrayFirst(columns, function (item) {
                return item.field === 'CustomerProfileName';
            });
            if (profileColumn) {
                profileColumn.hidden = false;
            }
            self.cpCustomerUsersTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CPCustomerUsers/GetCPCustomerUsers",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#cpcustomerusers-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    },
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "CPCustomerUser",
                    title: "CP Customer Users",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.cpCustomerUsersTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.cpCustomerUsersTable.getGridData().dataSource.read();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.cpActions.editCustomerUser(data.Id);
                event.preventDefault();
            }).on("click", ".btn-send", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.cpActions.sendInvitationConfirm(data.UserName);
                event.preventDefault();
            }).on("click", ".btn-send-app", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.cpActions.sendCustomerCounterPathCredentialsConfirm(data.Id, data.Email);
                event.preventDefault();
            }).on("click", ".btn-impersonate", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.cpActions.impersonateConfirm(data.UserName, data.CustomerProfileId);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.cpActions.deleteCustomerUserConfirm(data.Id, "".concat(data.FirstName, " ").concat(data.LastName));
                event.preventDefault();
            });
        };
        CPCustomerUsers.prototype.editCPCustomerUser = function (id) {
            var self = this;
            self.cpActions.editCustomerUser(id);
        };
        CPCustomerUsers.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("CPCustomerUser");
                dataLogs.open("CPCustomerUsers logs");
                event.preventDefault();
            }
        };
        CPCustomerUsers.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.cpCustomerUsersTable.exportTo();
            }
        };
        CPCustomerUsers.prototype.updateSystemRoles = function () {
            var self = this;
            if (UserContext.hasAccess("Admin")) {
                self.cpActions.confirmUpdateSystemRoles();
            }
        };
        return CPCustomerUsers;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/CPCustomerUsers/Index")) {
            log.log("Initialize CPCustomerUsers list");
            $(function () {
                (new CPCustomerUsers()).init();
            });
        }
    }, 0);
    return CPCustomerUsers;
});
//# sourceMappingURL=customerUsers.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customerPortalAdmin/customerUsers.js
// module id = 311
// module chunks = 2